// import { HttpInterceptorFn } from '@angular/common/http';
// import { inject } from '@angular/core';
// import { Router } from '@angular/router';
// import { catchError, throwError } from 'rxjs';
// import { AppRouters } from '../../constants/app-routers.router';

// export const ApiInterceptorInterceptor: HttpInterceptorFn = (req, next) => {
//   // *********** INJECT ROUTER ***********
//   const router = inject(Router);
//   // *********** LOG REQUEST ***********
//   console.log('request in api interceptor:', req.url);

//   const newReq = req.clone({
//     setHeaders: {
//       'Content-Type': 'application/json',
//       Accept: 'application/json',
//       Authorization: `Bearer ${localStorage.getItem('token')}`,
//     },
//   });

//   return next(newReq).pipe(
//     //
//     catchError(
//       //
//       (error) => {
//         // *********** CHECK STATUS ***********
//         if ([0].includes(error.status)) {
//           console.log('Error server request: ', error);
//           // *********** NAVIGATE TO ERRORS 404 ***********
//           //TODO: Uncomment this when the errors page is ready
//           // router.navigate([AppRouters.errors_404]);
//           //
//           return throwError(() => 'Error server request');
//         }

//         if ([401, 403].includes(error.status)) {
//           console.log('Unauthorized request: ', error);
//           localStorage.removeItem('token');
//           // navigate to sign in
//           router.navigate([AppRouters.auth_SignIn]);
//           return throwError(() => 'Unauthorized request');
//         }
//         // Safely extract an error message without assuming nested objects exist
//         const safeMessage =
//           (error && typeof error === 'object' && 'error' in error && error.error && error.error.message)
//             ? error.error.message
//             : (error && (error.message || error.statusText || error.stateText)) || 'Unexpected error';

//         console.error('e Error message in INSP: ', safeMessage);
//         console.error('Error message in INSP: ', error);
//         return throwError(() => ({ ...error, message: safeMessage }));
//       },
//     ),
//     //
//   );
// };

import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppRouters } from '../../constants/app-routers.router';
import { RequestDeduplicationService } from '../../services/request-deduplication.service';

export const ApiInterceptorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const requestDeduplicationService = inject(RequestDeduplicationService);

  // تحديد نوع body
  const isFormData = req.body instanceof FormData;
  const isBlob = req.body instanceof Blob;

  // Check if this is a file download request (for blob responses)
  const isFileRequest = req.url.includes('/uploads/') || req.url.includes('/download');

  // Check if this is an asset request (images, fonts, CSS, JS, etc.) - exclude from deduplication
  // Only exclude if it's clearly an asset, not an API request
  const isAssetRequest = 
    (!req.url.includes('/api/') && (
      req.url.includes('/assets/') ||
      req.url.endsWith('.css') ||
      req.url.endsWith('.js') ||
      req.url.endsWith('.woff') ||
      req.url.endsWith('.woff2') ||
      req.url.endsWith('.ttf') ||
      req.url.endsWith('.eot') ||
      req.url.endsWith('.svg') ||
      req.url.endsWith('.png') ||
      req.url.endsWith('.jpg') ||
      req.url.endsWith('.jpeg') ||
      req.url.endsWith('.gif') ||
      req.url.endsWith('.ico') ||
      req.url.endsWith('.webp')
    )) ||
    (req.url.startsWith('http') && !req.url.includes('/api/') && (
      req.url.includes('.css') ||
      req.url.includes('.js') ||
      req.url.includes('fonts.googleapis.com') ||
      req.url.includes('fonts.gstatic.com')
    ));

  // إعداد headers ذكي
  const headers: { [key: string]: string } = {
    Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
  };

  // Only set Accept and Content-Type for non-file requests
  if (!isFormData && !isBlob && !isFileRequest) {
    headers['Content-Type'] = 'application/json';
    headers['Accept'] = 'application/json';
  }

  const newReq = req.clone({ setHeaders: headers });

  // Skip deduplication for asset requests (they are different requests, not duplicates)
  if (isAssetRequest) {
    return next(newReq).pipe(
      catchError((error) => {
        // ======= معالجة أخطاء السيرفر =======
        if ([0].includes(error.status)) {
          console.error('Server request error:', error);
          return throwError(() => new Error('Server request error'));
        }

        // ======= معالجة عدم التفويض =======
        if ([401, 403].includes(error.status)) {
          console.warn('Unauthorized request:', error);
          localStorage.removeItem('token');
          router.navigate([AppRouters.auth_SignIn]);
          return throwError(() => new Error('Unauthorized request'));
        }

        // ======= استخراج رسالة الخطأ بأمان =======
        const safeMessage =
          error && typeof error === 'object' && 'error' in error && error.error && error.error.message
            ? error.error.message
            : (error && (error.message || error.statusText || error.stateText)) || 'Unexpected error';

        console.error('Error message in interceptor:', safeMessage);
        return throwError(() => ({ ...error, message: safeMessage }));
      }),
    );
  }

  // Use deduplication service to prevent duplicate API requests
  return requestDeduplicationService.deduplicateRequest(newReq, () => {
    return next(newReq).pipe(
      catchError((error) => {
        // ======= معالجة أخطاء السيرفر =======
        if ([0].includes(error.status)) {
          console.error('Server request error:', error);
          return throwError(() => new Error('Server request error'));
        }

        // ======= معالجة عدم التفويض =======
        if ([401, 403].includes(error.status)) {
          console.warn('Unauthorized request:', error);
          localStorage.removeItem('token');
          router.navigate([AppRouters.auth_SignIn]);
          return throwError(() => new Error('Unauthorized request'));
        }

        // ======= استخراج رسالة الخطأ بأمان =======
        const safeMessage =
          error && typeof error === 'object' && 'error' in error && error.error && error.error.message
            ? error.error.message
            : (error && (error.message || error.statusText || error.stateText)) || 'Unexpected error';

        console.error('Error message in interceptor:', safeMessage);
        return throwError(() => ({ ...error, message: safeMessage }));
      }),
    );
  });
};
